import ValidationRule from './validation.rule.js';

class ConfirmPasswordRule extends ValidationRule {
    constructor(manager, settings = {}) {
        super(manager, settings);
        const confirm = this.loadTarget(settings.confirm || this.getDefaultConfirmSelector());
        this.confirm = confirm;

        const password = this.loadTarget(settings.password || this.getDefaultPasswordSelector());
        this.password = password;

        if (this.confirm.element === null)  {
            throw `No valid confirm elt was found`;
        }

        const confirmElt = confirm.element;
        const passwordElt = password.element;
        this.generateFeedback(confirmElt);

        confirmElt.addEventListener('input', () => {
            this.onConfirmInput(confirm);
        });

        passwordElt.addEventListener('input', () => {
            this.onPasswordInput(password);
        });

        confirmElt.addEventListener('blur', () => {
            if (this.confirm.isActive === true) {
                this.refreshValidity();
            }

            this.confirm.isActive = false;
        });

        passwordElt.addEventListener('blur', async () => {
            if (password.isActive === true) {
                this.refreshConfirm();
            }

            else {
                confirmElt.setCustomValidity('');
            }

            password.isActive = false;
        });
    }


    clearValidity() {
        this.resetValidity(this.password.element);
        this.resetValidity(this.confirm.element);
    }

    refreshValidity() {
        if (this.confirm.isActive === true) {
            this.refreshConfirm();
        }

        else {
            this.confirm.element.setCustomValidity('');
        }

        this.confirm.isActive = false;
    }

    refreshFeedback() {
       this.refreshConfirm();
    }

    refreshConfirm() {
        this.check().then(isValid => {
            if (isValid === false) {
                this.invalidate(this.confirm.element);
            }
        });
    }

    getDefaultConfirmSelector()  {
        return `#${this.getFormID()} input[id="account-security-password-confirm"]`
    }

    getDefaultPasswordSelector() {
        return `#${this.getFormID()} input[id="account-security-password"]`
    }

    getRuleName() {
        return 'confirm-password';
    }


    onPasswordInput(password) {
        this.resetValidity(this.confirm.element);
        password.isActive = true;
    }

    onConfirmInput(confirm) {
        this.resetValidity(confirm.element);
        confirm.isActive = true;
    }

    async check() {
        return (
            this.confirm.element.value.length > 0 &&
            this.password.element.value.length > 0 &&
            this.confirm.element.value === this.password.element.value
        );
    }
}

export default ConfirmPasswordRule;
